import React from 'react'

const InsightsDetails = () => {
  return (
    <div>
      
    </div>
  )
}

export default InsightsDetails
